import { actionTypes, mutationTypes } from "./types";
import { getItem, setItem } from "@/store/persistantStorage";

export const actions = {
    [actionTypes.getWebsiteDatesfromLS]({ commit }, { userId, namespace = "lawebsitedates" }) {
        // LS persists only userId + period (per-mode). aabSiteIds (per-publisher) lives in
        // Publisher.selectedWebsites<Mode>; do not validate or store ids here.
        const stored = getItem(namespace) || {};
        // String comparison guards against type drift (some user ids come as strings from API).
        if (String(stored.userId) !== String(userId) || !stored.period) return;
        commit(mutationTypes.setData, {
            period:
                stored.period && typeof stored.period !== "string"
                    ? {
                          dateFrom: new Date(stored.period.timeFrom),
                          dateTo: new Date(stored.period.timeTo),
                      }
                    : stored.period,
        });
    },
    [actionTypes.setWebsiteDatesToLS]({ commit }, { period, aabSiteIds, userId, namespace = "lawebsitedates" }) {
        // LS persists only userId + period. Vuex still tracks aabSiteIds for the
        // current request payload; persistence of the selection is in Publisher store.
        setItem(namespace, {
            userId,
            period:
                period && typeof period !== "string"
                    ? {
                          timeFrom: period.dateFrom.getTime(),
                          timeTo: period.dateTo.getTime(),
                      }
                    : period,
        });
        commit(mutationTypes.setData, { aabSiteIds, period });
    },
    [actionTypes.setAvailableSlotNamesToLS]({ commit, state }, { availableSlotNames, namespace = "lawebsitedates" }) {
        let data = getItem(namespace) || {};
        data.availableSlotNames = availableSlotNames || state.data?.availableSlotNames || [];

        setItem(namespace, data);
        // Only merge availableSlotNames into Vuex — LS keeps `period` as
        // {timeFrom,timeTo} but Vuex expects {dateFrom,dateTo}; committing the
        // raw LS object would corrupt the period and break later requests.
        commit(mutationTypes.setData, { availableSlotNames: data.availableSlotNames });
    },
};
